import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
export default new VueI18n({
  locale: 'en',
  messages: {
    en: {
      '': '',
      freight_intelligence: 'Freight Intelligence',
      freight_intelligence_maritime: 'Freight Intelligence Maritime',
      more_solutions: 'More Solutions',
      contact: 'Contact',
      client_area: 'Client Area',
      slide_gallery_msg: 'The tracking platform all-in-one for...',
      slide_update_status: 'Keep track on your cargo status and location',
      slide_centralize_info: 'Centralize information',
      slide_automate_tracking: 'Automate your containers tracking',
      slide_create_alerts: 'Create Alerts and reports',
      product_info_title: 'An All-in-One Platform',
      product_info_title_2: 'Better informed decisions',
      product_info_1: '{0} is a container shipment tracking platform designed to {1} and {2} maritime logistics management. With this tool, you can conveniently monitor the real-time status and positions of your containers from a single {3} platform.',
      product_info_2: 'Forget about the manual process of checking and tracking information related to your containers on each shipping line\'s website or making calls and sending emails. Centralize them all in {0}, which will update the information for you.',
      simplify: 'simplify',
      streamline: 'streamline',
      centralized: 'centralized',
      product_card_1_title: 'Dashboard',
      product_card_2_title: 'Alerts & Notifications',
      product_card_3_title: 'Real-time location',
      product_card_1_text: 'Easily visualize the current {0} of your shipments and identify those that require your attention at a {1}.',
      status: 'status',
      glance: 'glance',
      product_card_2_text: 'Create {0} and {1}. Choose between more than 200 fields. Schedule them to be sent to you and your colleagues by {2}.',
      alerts: 'alerts',
      reports: 'reports',
      email: 'E-mail',
      product_card_3_text: 'We combine a {0} with integration with different shipping lines to provide {1} results.',
      satelital_system: 'satellite system',
      reliable: 'reliable',
      product_info_3: 'Enhance {0} in your shipping line for {1} decision-making.',
      visibility: 'visibility',
      better: 'better',
      product_info_4: 'Stay one step ahead of delays and other issues. Easily check planned and confirmed dates for each port or destination at a glance. Avoid surprises and ensure {0} operations with the most reliable tracking tool. Streamline your logistics and choose {1}',
      smooth: 'smooth',
      peace_of_mind: 'peace of mind',
      product_features_title: 'SIMPLIFY CONTAINER TRACKING',
      product_feature_title_1: 'A centralized platform',
      product_feature_text_1_1: 'All your containers {0}, regardless of the shipping company. Save time and effort by checking all your shipments {1}.',
      at_one_place: 'in one place',
      at_a_glance: 'at a glance',
      product_feature_text_1_2: 'Easily filter tracking requests and shipments, export lists with the template tool, and much more.',
      product_feature_title_2: 'Joining forces',
      product_feature_text_2_1: '{0} is integrated with services like {1} and {2}. You can also integrate the platform with your ERP to further streamline container tracking as all information will be updated {3}. You\'ll only need to access your ERP to check the expected and actual dates, along with a range of useful information to {4}.',
      libra: 'Libra',
      vforwarding: 'VForwarding',
      automatically: 'automatically',
      facilitate_tracking: 'facilitate tracking',
      product_feature_text_2_2: 'Additionally, we offer an API in case you need to integrate your {0} or any other management tool.',
      erp: 'ERP',
      product_feature_title_3: 'Satellite Tracking',
      product_feature_text_3_1: 'Powered by {0}, pinpoint the exact coordinates of your containers.',
      google_maps: 'Google Maps',
      product_feature_text_3_2: 'Filter by Port, Origin, or Location for quick and {0}.',
      easy_tracking: 'easy tracking',
      product_feature_text_3_3: 'Check your shipment summaries by clicking on vessel markers and access {0} within your shipment and delivery details.',
      more_information: 'more information',
      product_feature_title_4: 'Proactive Logistics',
      product_feature_text_4_1: 'Track the {0} of your containers, from container pickup at the depot to its empty delivery.',
      complete_route: 'complete route',
      product_feature_text_4_2: 'Obtain detailed, {0}, and {1} data throughout your container\'s journey that will assist you in decision-making and interpreting massive data about route behavior and providers.',
      reliables: 'reliable',
      actionable: 'actionable',
      product_feature_title_5: 'Total Transparency',
      product_feature_text_5_1: 'An extensive {0} spanning various situations. A history of changes reflecting every status or modification the shipment has gone through.',
      record_of_events: 'record of events',
      product_feature_text_5_2: 'Add {0} and complete {1} to the delivery process, providing {2} and {3} at each stage.',
      transparency: 'transparency',
      confidence: 'confidence',
      clarity: 'clarity',
      product_feature_title_6: 'Pay as you go',
      product_feature_text_6_1: 'No matter the number of containers you want to track, {0} your costs with the pay-as-you-go model. Forget about paying for a license, simply {1}.',
      optimize: 'optimize',
      pay_based: 'pay based on your annual container volume',
      more_info_question: 'Need moore info?',
      contact_us: 'Contact us',
      privacy_policy: 'Privacy Policy',
      terms_conditions: 'Terms & conditions',
      alarms: 'Alerts',
      services: 'Services',
      products: 'Products',
      legal_advice: 'Legal Advice',
      back: 'Back',
      request_information: 'Request Information',
      accept_terms_conditions: 'I accept the {0} & {1}',
      send: 'Send',
      digitalization: 'Digitalization',
      name: 'Name',
      phone: 'Phone',
      company: 'Company',
      remarks: 'Remarks',
      please_accept_terms: 'Please, accept the Terms and Conditions and the Privacy Policy.',
      empty: '{field} must not be blank.',
      request_success: 'Request sent successfully!',
      download_flyer: 'Download Flyer'
    },
    es: {
      '': '',
      freight_intelligence: 'Freight Intelligence',
      freight_intelligence_maritime: 'Freight Intelligence Maritime',
      more_solutions: 'Otras Soluciones',
      contact: 'Contacto',
      client_area: 'Área Cliente',
      slide_gallery_msg: 'La plataforma de tracking todo en uno para...',
      slide_update_status: 'Actualizar el estado y las posiciones de la carga',
      slide_centralize_info: 'Centralizar la información',
      slide_automate_tracking: 'Automatizar el seguimiento de tus contenedores',
      slide_create_alerts: 'Crear alertas e informes',
      product_info_title: 'Una Plataforma todo en uno',
      product_info_title_2: 'Mejora tu proceso de decisión',
      product_info_1: '{0} es una plataforma de seguimiento de embarques en contenedores  diseñada para {1} y {2} la gestión logística. Con esta herramienta, podrás supervisar de manera {3} y en tiempo real los estados de tus contenedores y sus posiciones.',
      product_info_2: 'Olvídate del proceso manual de consultar y seguir la información relativa a tus contenedores en las páginas web de cada naviera o llamando o escribiendo emails. Centralizalos todos en {0} quien hará la actualización de la información para ti.',
      simplify: 'simplificar',
      streamline: 'agilizar',
      centralized: 'centralizada',
      product_card_1_title: 'Panel de Control',
      product_card_2_title: 'Alertas & notificaciones',
      product_card_3_title: 'Ubicación en tiempo real',
      product_card_1_text: 'Visualiza fácilmente el {0} actual de tus envíos y detecta los que requieren de tu atención de un solo {1}.',
      status: 'estado',
      glance: 'vistazo',
      product_card_2_text: 'Crea {0} e {1}. Elige entre más de 200 campos. Prográmalos para que lleguen a ti y tus compañeros por {2}.',
      alerts: 'alertas',
      reports: 'informes',
      email: 'E-mail',
      product_card_3_text: 'Combinamos un {0} con la integración con diferentes navieras para dar resultados {1}.',
      satelital_system: 'sistema satelital',
      reliable: 'fiable',
      product_info_3: 'Mejora la {0} en tu linea de envio para {1} la toma de decisiones.',
      visibility: 'visibilidad',
      better: 'mejorar',
      product_info_4: 'Mantente un paso adelante de los retrasos y otros problemas. Verifica fácilmente las fechas planificadas y confirmadas para cada puerto o destino de un vistazo. Evita sorpresas y garantiza operaciones {0} con la herramienta de seguimiento más confiable. Agiliza tu logística y opta por la {1}.',
      smooth: 'fluidas',
      peace_of_mind: 'tranquilidad',
      product_features_title: 'SIMPLIFICA EL RASTREO DE CONTENEDORES',
      product_feature_title_1: 'Una plataforma centralizada',
      product_feature_text_1_1: 'Todos tus contenedores {0}, sin importar la compañía de envío. Ahorra tiempo y esfuerzo al verificar todos tus envíos {1}.',
      at_one_place: 'en un solo lugar',
      at_a_glance: 'de un vistazo',
      product_feature_text_1_2: 'Filtra fácilmente las solicitudes de seguimiento y los envíos, exporta listas con la herramienta de plantillas y mucho más.',
      product_feature_title_2: 'Uniendo fuerzas',
      product_feature_text_2_1: '{0} está integrado con servicios como {1} y {2}. También puedes integrar la plataforma con tu ERP y facilitar aún más el seguimiento de tus contendores ya que toda la información se actualizará de {3}. Solo tendrás que acceder a tu ERP para consultar las fechas previstas y reales, así como toda una serie de información de interés para {4}.',
      libra: 'Libra',
      vforwarding: 'VForwarding',
      automatically: 'forma automática',
      facilitate_tracking: 'facilitar el seguimiento',
      product_feature_text_2_2: 'También disponemos de una API por si necesitas integrar tu {0} u cualquier otra herramienta de gestión.',
      erp: 'ERP',
      product_feature_title_3: 'Rastreo por satélite',
      product_feature_text_3_1: 'Impulsado por {0}, encuentra las coordenadas exactas de tus contenedores.',
      google_maps: 'Google Maps',
      product_feature_text_3_2: 'Filtra por Heath, Origen o Ubicación para un {0} y sencillo.',
      easy_tracking: 'seguimiento rápido',
      product_feature_text_3_3: 'Verifica el resumen de tus envíos haciendo clic en los marcadores de buque y encuentra más información dentro de los detalles de tus expediciones y recepciones.',
      more_information: 'más información',
      product_feature_title_4: 'Logística Proactiva',
      product_feature_text_4_1: 'Trackea la {0} de tus contenedores, desde la recogida del contenedor en el depot hasta la entrega de este mismo vacío.',
      complete_route: 'ruta completa',
      product_feature_text_4_2: 'Obten datos detallados, {0} y {1} durante todo el trayecto de tus contenedores que te ayudarán en la toma de decisiones y a la interpretación de datos masivos sobre el comportamiento de las rutas y proveedores.',
      reliables: 'fiables',
      actionable: 'explotables',
      product_feature_title_5: 'Transparencia Total',
      product_feature_text_5_1: 'Un amplio {0} que abarca una variedad de situaciones. Un historial de cambios que refleja cada estado o modificación por la que ha pasado el envío.',
      record_of_events: 'registro de eventos',
      product_feature_text_5_2: 'Añade {0} y {1} completa al proceso de entrega, brindando {2} y {3} en cada etapa.',
      transparency: 'transparencia',
      confidence: 'confianza',
      clarity: 'claridad',
      product_feature_title_6: 'Pago por uso',
      product_feature_text_6_1: 'No importa el número de contenedores que quieres rastrear, {0} tus costes con el modelo de pago por uso. Olvídate de pagar una licencia, simplemente {1} anual de contenedores.',
      optimize: 'optimiza',
      pay_based: 'paga según tu volumen',
      more_info_question: '¿Necesitas más información?',
      contact_us: 'Contacta con nosotros',
      privacy_policy: 'Politica de Privacidad',
      terms_conditions: 'Terminos & condiciones',
      alarms: 'Alertas',
      services: 'Servicios',
      products: 'Productos',
      legal_advice: 'Aviso Legal',
      back: 'Volver',
      request_information: 'Solicita Información',
      accept_terms_conditions: 'Acepto los {0} y la {1}',
      send: 'Enviar',
      digitalization: 'Digitalización',
      name: 'Nombre',
      phone: 'Teléfono',
      company: 'Empresa',
      remarks: 'Comentarios',
      please_accept_terms: 'Por favor, acepta los terminos y condiciones y la política de privacidad.',
      empty: '{field} no puede estar vacio.',
      request_success: '¡Petición enviada correctamente!',
      download_flyer: 'Descargar Flyer'
    }
  }
})



// WEBPACK FOOTER //
// ./src/language.js